import { Tooltip } from "@mui/material";
import { ReactComponent as CoinSvg } from "../assets/images/coin.svg";
import { useEffect, useState } from "react";

export const tokensCost = (
  tokens: number,
  style: { fontSize: string; width?: number; height?: number } = {
    fontSize: "",
    width: 0,
    height: 0,
  }
) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "1px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CoinSvg width={style?.width || 20} height={style?.height || 20} />
      <div
        style={{
          fontSize: style?.fontSize || "11px",
          fontWeight: "500",
          marginLeft: "-1px",
          // color: "white",
        }}
      >
        ~{tokens}
      </div>
    </div>
  );
};

export const tokenBalanceDisplay = (tokens: number) => {
  return (
    <Tooltip title={`${tokens} tokens remaining`}>
      <div>
        <CoinSvg width={35} height={35} />
        <div style={{ fontSize: "13px" }}>{`${tokens}`}</div>
      </div>
    </Tooltip>
  );
};

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
